if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        // Initialisation des éléments du formulaire
        this.form = this.querySelector('form');
        this.variantIdInput = this.form.querySelector('[name="id"]');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.hideErrors = this.dataset.hideErrors === 'true';

        // Activation du champ de variante
        this.variantIdInput.disabled = false;

        // Attachement de l'écouteur d'événement pour la soumission du formulaire
        this.attachEventListeners();

        // Configuration du bouton pour les paniers modaux
        if (this.cart) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
      }

      // Méthode pour attacher les écouteurs d'événements
      attachEventListeners() {
        // Supprime l'ancien écouteur pour éviter les duplications
        this.form.removeEventListener('submit', this.onSubmitHandler.bind(this));
        // Attache le nouvel écouteur
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      // Gestionnaire de soumission du formulaire
      onSubmitHandler(evt) {
        evt.preventDefault();

        // Si le bouton est désactivé, on ne fait rien
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Gestion des messages d'erreur
        this.handleErrorMessage();

        // Désactivation du bouton pendant le traitement
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // Configuration de la requête fetch
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        // Préparation des données du formulaire
        const formData = new FormData(this.form);

        // Ajout des sections à mettre à jour dans le panier
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        // Envoi de la requête pour ajouter au panier
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // Gestion des erreurs (produit épuisé, etc.)
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              // Affichage du message "Épuisé" si nécessaire
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (soldOutMessage) {
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
              }
              return;
            } else if (!this.cart) {
              // Redirection vers la page du panier si le panier n'est pas affiché
              window.location = window.routes.cart_url;
              return;
            }

            // Mise à jour du panier
            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }
            this.error = false;

            // Gestion des modaux rapides
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            // Réactivation du bouton après le traitement
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      // Gestion des messages d'erreur
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      // Activation/désactivation du bouton de soumission
      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
    }
  );
}